import * as React from "react";
function SvgStar(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M16 1.73l4.64 9.4L31 12.63l-7.5 7.31 1.77 10.33L16 25.39l-9.27 4.88L8.5 19.94 1 12.63l10.37-1.5L16 1.73z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgStar);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
